import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  SkipSelf,
} from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { Material } from '../../../../materials/material'
import { ControlContainer, FormsModule } from '@angular/forms'
import { BomComponent, NamedBomComponent } from '../bom'
import { MaterialComponent } from '../material-component'
import { ProductSalesQuantityPipe } from '../../../../../features/pipes/product-sales-quantity.pipe'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BomPropertySetDetailComponent } from '../bom-property-set-detail/bom-property-set-detail.component'
import { MatInput } from '@angular/material/input'
import {
  ElderFormFieldDenseDirective,
  ElderFormFieldLabelDirective,
  ElderQuantityInputControlComponent,
  ElderQuantityRangeValidator,
  ElderRequiredQuantityValidator,
  ElderValidationErrorDirective,
} from '@elderbyte/ngx-starter'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-bom-item-detail',
  templateUrl: './bom-item-detail.component.html',
  styleUrls: ['./bom-item-detail.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new Optional(), new SkipSelf(), ControlContainer]],
    },
  ],
  imports: [
    MatFormField,
    ElderFormFieldLabelDirective,
    MatLabel,
    MatInput,
    FormsModule,
    ElderFormFieldDenseDirective,
    ElderQuantityInputControlComponent,
    ElderRequiredQuantityValidator,
    ElderQuantityRangeValidator,
    MatError,
    ElderValidationErrorDirective,
    BomPropertySetDetailComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ProductSalesQuantityPipe,
  ],
})
export class BomItemDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly MaterialComponent = MaterialComponent

  private readonly logger = LoggerFactory.getLogger(this.constructor.name)

  public readonly bomItem$ = new BehaviorSubject<NamedBomComponent>(null)
  public readonly configJson$ = new BehaviorSubject<string>(null)

  @Output()
  public readonly bomItemChanged = new EventEmitter<BomComponent>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set bomItem(bomItem: NamedBomComponent) {
    this.bomItem$.next(bomItem)

    if (bomItem?.component?.config) {
      this.configJson$.next(this.formatJson(bomItem.component.config.data))
    }
  }

  public set material(material: Material) {
    const namedBomComponent = this.bomItem$.getValue()

    if (!namedBomComponent?.component) {
      return
    }
    const bomItem = namedBomComponent.component

    if (material) {
      if (!bomItem.material) {
        bomItem.material = new MaterialComponent()
      }

      bomItem.material.materialId = material.id

      /*
      if (bomItem.material.quantity) {
        bomItem.material. = Quantity.from(material.stockUnit, bomItem.quantity.value);
      } else {
        bomItem.quantity = Quantity.from(material.stockUnit);
      }*/
    } else {
      bomItem.material.materialId = null
      bomItem.material.quantity = null
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public Api                                                              *
   *                                                                         *
   **************************************************************************/

  private formatJson(raw: any): string {
    try {
      return JSON.stringify(raw, null, 4)
    } catch (e) {
      this.logger.warn('Failed to format content as json!', e)
    }
    return raw
  }
}
